import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon//locked.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import addCheck from "../../../public/BP_resources/images/icon/addcheck.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import EditMedicalBill from "../TreatmentPage/modals/edit-medical-bill/editMedicalBill";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import { currencyFormat, formatCalendarDate } from "../../Utils/helper";
import ClientProvidersStyles from "../CaseDashboard/ClientProvidersStyles";
import EditLoans from "../Modals/EditLoans";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";

import SettlementCosts from "./SettlementCosts";
import updateLockSettleValue from "./common/updateLockSettleValue";
import updateLockSettleAmount from "./common/updateLockSettleAmount";
import AllLockSettle from "./common/AllLockSettle";
import SettlementRecentOffers from "./SettlementRecentOffers";
import OffersFeeTable from "./OffersFeeTable";
import ChequeUpload from "./ChequeUpload";
import CopyValueSettlement from "./common/CopyValueSettlement";
import updateRightColumnValue from "./common/updateRightColumnValue";
import SectionActionBar from "./SectionActionBar";
import ClientProceeds from "./ClientProceeds";
import InsuranceLiensTable from "./InsuranceLiensTable";
import OtherLiensTable from "./OtherLiensTable";
import FirmCounselingLiensTable from "./FirmCounselingLiensTable";
import OpposingCounselingLiensTable from "./OpposingCounselingLiensTable";
import SettlementEmptyMessage from "./SettlementEmptyMessage";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import SettlementCurrencyInput, {
  getSettlementCurrencyInputSum,
} from "./common/SettlementCurrencyInput";
import { hasNonZeroSettlementAmount, hasSettlementCheck } from "./common/settlementCheckGuards";

const SettlementTable = ({
  clientProceeds,
  offersObj,
  feesObj,
  costsObj,
  medicalBillsObj,
  insuranceLiensObj,
  otherLiensObj,
  loansObj,
  costsReimbursementsObj,
  trustLedgerObj,
  offerCombinations,
  updateGroupedOffersState,
  settlementObjProps,
  initialOffers,
  firmCounselObj,
  opposingCounselObj,
}) => {
  // const countRef = useRef(0);
  // const [isHovered, setIsHovered] = useState({ id: -1, value: false });
  const [showSettlementPopup1, setShowSettlementPopup1] = useState(false);
  const [showSettlementPopup2, setShowSettlementPopup2] = useState(false);
  const variableColumnWidths = () => {
    const CheckReqColumns = [...document.querySelectorAll(".check-request--btn-settle")];
    if (CheckReqColumns.length === 0) return;
    let checkReqMaxWidth = 0;
    CheckReqColumns.forEach((col) => {
      const colWidth = col.offsetWidth;
      if (colWidth > checkReqMaxWidth) {
        checkReqMaxWidth = colWidth;
      }
    });
    CheckReqColumns.forEach((col) => {
      col.style.minWidth = `${checkReqMaxWidth}px`;
      col.style.width = `${checkReqMaxWidth}px`;
    });
  };
  const providerWidthRef = useRef(0);
  const [isWide, setIsWide] = useState(document.documentElement.clientWidth > 1530);
  const MAX_PROVIDER_COL = 220; // ceiling only used below 1500

  const variableProviderColWidth = () => {
    const actualProviderColumns = [...document.querySelectorAll(".actual-provider-col")];
    const providerNameCols = [...document.querySelectorAll(".sec-provider-name-2")];
    if (actualProviderColumns.length === 0) return;

    const wide = document.documentElement.clientWidth > 1530;
    setIsWide(wide);

    let contentMax = 0;
    providerNameCols.forEach((col) => {
      const nameP = col.querySelector("p");
      const logo = col.querySelector(".logo-specialty-provider");
      if (!nameP) return;
      const prev = nameP.style.whiteSpace;
      nameP.style.whiteSpace = "nowrap";
      const w = nameP.scrollWidth + (logo?.offsetWidth || 0);
      nameP.style.whiteSpace = prev;
      if (w > contentMax) contentMax = w;
    });
    if (contentMax === 0) return;

    let target;
    if (wide) {
      target = contentMax; // size-to-content, no ratchet, no ceiling
      providerWidthRef.current = 0; // reset so going back narrow recomputes clean
    } else {
      target = Math.min(Math.max(contentMax, providerWidthRef.current), MAX_PROVIDER_COL);
      providerWidthRef.current = target;
    }

    actualProviderColumns.forEach((col) => {
      col.style.minWidth = `${target}px`;
      col.style.width = `${target}px`;
      col.style.maxWidth = `${target}px`;
    });
  };
  // const variableProviderColWidth = () => {
  //   // const providerColumns = [...document.querySelectorAll('.first-col')];
  //   const actualProviderColumns = [...document.querySelectorAll(".actual-provider-col")];
  //   const providerNameCols = [...document.querySelectorAll(".sec-provider-name-2")];
  //   if (actualProviderColumns.length === 0) return;
  //   let providerMaxWidth = 0;
  //   providerNameCols.forEach((col) => {
  //     const colWidth = col.offsetWidth;
  //     if (colWidth > providerMaxWidth) {
  //       providerMaxWidth = colWidth + 60;
  //     }
  //   });
  //   if (document.documentElement.clientWidth <= 1500 && countRef.current === 0) {
  //     countRef.current = 1;
  //     providerMaxWidth = (2 / 3) * providerMaxWidth;
  //     actualProviderColumns.forEach((col) => {
  //       col.style.minWidth = `${providerMaxWidth}px`;
  //       col.style.width = `${providerMaxWidth}px`;
  //       col.style.maxWidth = `${providerMaxWidth}px`;
  //     });

  //     if (providerNameCols.length === 0) return;
  //     // providerNameCols.forEach((col) => {
  //     //   col.classList.add("prov-name");
  //     // });
  //   } else if (document.documentElement.clientWidth > 1500) {
  //     let maxWidth = 0;
  //     providerNameCols.forEach((col) => {
  //       const colWidth = col.offsetWidth;
  //       if (colWidth > maxWidth) {
  //         maxWidth = colWidth + 60;
  //       }
  //     });
  //     actualProviderColumns.forEach((col) => {
  //       col.style.minWidth = `${maxWidth}px`;
  //       col.style.width = `${maxWidth}px`;
  //       col.style.maxWidth = `${maxWidth}px`;
  //     });
  //     if (countRef.current === 1) {
  //       actualProviderColumns.forEach((col) => {
  //         col.style.minWidth = `${maxWidth}px`;
  //         col.style.width = `${maxWidth}px`;
  //         col.style.maxWidth = `${maxWidth}px`;
  //       });
  //     }

  //     if (providerNameCols.length === 0) return;
  //     // providerNameCols.forEach((col) => {
  //     //   if (col.classList.contains("prov-name")) col.classList.remove("prov-name");
  //     // });

  //     countRef.current = 0;
  //   }
  // };
  const variableCurrencyColWidth = () => {
    const currencyColumns = [...document.querySelectorAll(".med-bill-width")];

    if (currencyColumns.length === 0) return;
    let currencyMaxWidth = 0;
    currencyColumns.forEach((col) => {
      const colWidth = col.offsetWidth;
      if (colWidth > currencyMaxWidth) {
        currencyMaxWidth = colWidth;
      }
    });
    currencyColumns.forEach((col) => {
      col.style.minWidth = `${currencyMaxWidth}px`;
      col.style.width = `${currencyMaxWidth}px`;
    });
  };
  const lockAllMedBills = (bType, boolVal) => {
    AllLockSettle("provider", bType, boolVal);
    if (bType === "draft1") {
      setMedicalBillsLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setMedicalBillsLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: hasSettlementCheck(row) ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const lockAllLoans = (bType, boolVal) => {
    AllLockSettle("loans", bType, boolVal);
    if (bType === "draft1") {
      setLoansLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setLoansLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: hasSettlementCheck(row) ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const handleDraftLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "medical_bills") {
      const lock = medicalBillsLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "provider", "draft1");
      setMedicalBillsLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row
        )
      );
    } else if (sectionName === "loans") {
      const lock = loansLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "loans", "draft1");
      setLoansLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row
        )
      );
    }
  };

  const handleFinalLockChange = (id, sectionName, e) => {
    e.stopPropagation();
    if (sectionName === "medical_bills") {
      const lock = medicalBillsLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "provider", "final");
      setMedicalBillsLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row
        )
      );
    } else if (sectionName === "loans") {
      const lock = loansLocks.find((row) => row.id === id);
      if (hasSettlementCheck(lock)) {
        handleCheckedRowClick(e);
        return;
      }
      updateLockSettleValue(id, "loans", "final");
      setLoansLocks((prevStates) =>
        prevStates.map((row) =>
          row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row
        )
      );
    }
  };

  const {
    medicalBillsLocks,
    setMedicalBillsLocks,
    medicalBills,
    medicalBillFinalAmount,
    medicalBillLockValues,
    setMedicalBillLockValues,
    showMedBillModal,
    handleMedBillClose,
    handleMedBillShow,
    currentMedicalBill,
    setCurrentMedicalBill,
    showErrorModal,
    handleErrorClose,
    handleErrorShow: _handleErrorShow,
    updateMedicalBillsState,
  } = medicalBillsObj;
  const {
    loansLocks,
    setLoansLocks,
    loans,
    setLoans,
    loansFinalAmount,
    loansLockValues,
    showLoanModal,
    handleLoanClose,
    handleLoanShow,
    currentLoan,
    setCurrentLoan,
    showErrorLoanModal,
    setLoansLockValues,
    handleLoanErrorClose,
    handleLoanErrorShow: _handleLoanErrorShow,
    updateLoansState,
  } = loansObj;

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [currentCheck, setCheck] = useState({});
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [showModal, showEditCostModal] = useState(false);

  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };

  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);

  const [showLoanCheckRequestModal, setLoanCheckRequestModal] = useState(false);
  const handleLoanCheckRequestClose = () => setLoanCheckRequestModal(false);

  const [errorMsg, _setMsgError] = useState("");

  const [colSpanValue, setColSpanValue] = useState(
    document.documentElement.clientWidth < 1530
      ? 5
      : document.documentElement.clientWidth < 2070
        ? 6
        : 9
  );
  useEffect(() => {
    const handleResize = () => {
      setColSpanValue(
        document.documentElement.clientWidth < 1530
          ? 5
          : document.documentElement.clientWidth < 2070
            ? 6
            : 9
      );
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    variableCurrencyColWidth();
    variableColumnWidths();
  }, [
    medicalBills,
    costsObj.itemizedCost,
    costsReimbursementsObj.costsReimbursements,
    loans,
    clientProceeds.checks,
    otherLiensObj.otherLiens,
    insuranceLiensObj.insuranceLiens,
    offersObj.groupedOffers,
    opposingCounselObj.updateOpposingCounselingStates,
    firmCounselObj.updateFirmCounselingStates,
  ]);

  useEffect(() => {
    const handleResize = () => {
      variableProviderColWidth();
      variableColumnWidths();
    };
    variableProviderColWidth();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [medicalBills]);
  return (
    <div style={{ marginTop: "0px" }}>
      <ClientProvidersStyles clientProviders={medicalBills} />
      {offersObj?.offers && offersObj?.offers?.length > 0 && (
        <SettlementRecentOffers
          offersObj={offersObj}
          updateGroupedOffersState={updateGroupedOffersState}
          trustLedgerObj={trustLedgerObj}
          feesObj={feesObj}
          clientProceed={clientProceeds.clientProceed}
          setClientProceed={clientProceeds.setClientProceed}
          updateClientProceedStates={clientProceeds.updateClientProceedsState}
          offerCombinations={offerCombinations}
          settlementObjProps={settlementObjProps}
        />
      )}
      {feesObj?.fees && feesObj?.fees?.length > 0 && (
        <OffersFeeTable
          initialOffers={initialOffers}
          clientProceeds={clientProceeds}
          feesObj={feesObj}
          settlementObjProps={settlementObjProps}
        />
      )}
      {Object.keys(costsObj?.itemizedCost?.chv_settle)?.length > 0 && (
        <SettlementCosts
          costsObj={costsObj}
          clientProceed={clientProceeds}
          costsReimbursementsObj={costsReimbursementsObj}
          settlementObjProps={settlementObjProps}
        />
      )}
      {medicalBills && medicalBills?.length > 0 && (
        <div className="m-t-5">
          <SectionActionBar sectionName={"Treatment"} />
          <div className="table--no-card rounded-0 border-0 w-100">
            <table className="table table-borderless table-striped table-earning settlement-table">
              {medicalBills.length > 0 && (
                <thead>
                  <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                    <th className="" />
                    <th className="td-autosize text-center provider-col">Provider</th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width show-table-data">
                      Bills / -{" "}
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width bills-data">
                      {colSpanValue === 9
                        ? "Original Billing"
                        : colSpanValue === 6
                          ? "Billing"
                          : "Billing"}
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width hide-table-data">
                      HI Paid
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width hide-table-data">
                      HI Reduc
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width hide-table-data">
                      MEDPAY/PIP
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width hide-table-data">
                      Client Paid
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width hide-table-data">
                      REDUCTION
                    </th>
                    <th className="text-end dollar-amount-value td-autosize med-bill-width mid-table-data">
                      Debits
                    </th>
                    {/* <th className="text-end dollar-amount-value td-autosize med-bill-width">Lien</th> */}
                    <th className="big-n-4 " />
                    <th
                      className={`text-end td-autosize ${medicalBillsLocks?.some((lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                      // style={{ color: "var(--primary-25) !important" }}
                      onClick={() => {
                        const draftLockCheck = medicalBillsLocks?.some(
                          (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                        );
                        if (draftLockCheck) {
                          medicalBillsLocks?.forEach((medBill, index) => {
                            if (!medBill.isDraftLocked && !hasSettlementCheck(medBill)) {
                              updateRightColumnValue(
                                medBill.isDraftLocked,
                                medBill.isFinalLocked,
                                setMedicalBillsLocks,
                                "bill-draft",
                                medBill.id,
                                medicalBillLockValues,
                                setMedicalBillLockValues,
                                "provider",
                                "draft1",
                                medicalBills[index].final_amount
                              );
                            }
                          });
                          updateMedicalBillsState();
                          clientProceeds.updateClientProceedsState();
                        }
                      }}
                    >
                      <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                        {medicalBillsLocks?.some(
                          (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                        ) && <CopyValueSettlement />}
                        Lien
                      </span>
                    </th>
                    <th
                      className={`s-draft text-end ${medicalBillsLocks?.some((lock) => lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                      style={{ color: "var(--primary-25) !important" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        const finalLockCheck = medicalBillsLocks?.some(
                          (lock) =>
                            lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                        );
                        if (finalLockCheck) {
                          medicalBillsLocks?.forEach((medBill) => {
                            if (
                              medBill.isDraftLocked &&
                              !medBill.isFinalLocked &&
                              !hasSettlementCheck(medBill)
                            ) {
                              updateRightColumnValue(
                                medBill.isDraftLocked,
                                medBill.isFinalLocked,
                                setMedicalBillsLocks,
                                "bill-final",
                                medBill.id,
                                medicalBillLockValues,
                                setMedicalBillLockValues,
                                "provider",
                                "final",
                                medBill.isDraftAmount
                              );
                            }
                          });
                          clientProceeds.updateClientProceedsState();
                        }
                      }}
                    >
                      <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                        <div className="d-flex align-items-center position-relative">
                          <img
                            className="invisible ic ic-19"
                            id="lock-image"
                            src={unlocked}
                            alt="lock-icon"
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="lock-image"
                            className="ic ic-19 lock-icon"
                            src={unlocked}
                            alt="lock-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllMedBills("draft1", "false");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="unlock-image"
                            className="ic ic-19 lock-icon"
                            alt="lock-icon"
                            src={draftLocked}
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllMedBills("draft1", "true");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <span
                          className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                          style={{ paddingRight: "2px" }}
                        >
                          {medicalBillsLocks?.some(
                            (lock) =>
                              lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                          ) && <CopyValueSettlement />}
                          <span className="position-absolute right-0">Draft</span>
                        </span>
                      </div>
                    </th>
                    <th
                      className="s-final text-end"
                      style={{ color: "var(--primary-25) !important" }}
                    >
                      <div className="d-flex justify-content-between align-items-center height-25">
                        <div className="d-flex align-items-center">
                          <img
                            className="invisible ic ic-19"
                            id="lock-image"
                            src={unlocked}
                            alt="lock-icon"
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="lock-image"
                            className="ic ic-19"
                            src={unlocked}
                            alt="lock-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllMedBills("final", "false");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="unlock-image"
                            className="ic ic-19"
                            alt="lock-icon"
                            src={locked}
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllMedBills("final", "true");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                        <span style={{ paddingRight: "2px" }}>Final</span>
                      </div>
                    </th>
                    <th className="s-verify" />
                    <th
                      className="td-autosize check-request--btn-settle text-center"
                      style={{ color: "var(--primary-25) !important" }}
                    >
                      Check
                    </th>
                  </tr>
                </thead>
              )}
              <tbody id="body-table">
                <>
                  {medicalBills?.length === 0 && (
                    <tr id="cost-settle-row" className="add-btn-row cursor-default padding-tr-0">
                      <td className="text=center cursor-pointer" colSpan={colSpanValue + 5}>
                        <SettlementEmptyMessage
                          name="PROVIDERS"
                          onClick={(e) => {
                            e.stopPropagation();
                            setShowSettlementPopup1(true);
                          }}
                        />
                      </td>
                    </tr>
                  )}
                  {medicalBills.length > 0 &&
                    medicalBills?.map((medicalBill, index) => (
                      <React.Fragment>
                        <tr
                          key={index}
                          className={`${colSpanValue === 5 && medicalBill?.checkID?.length === 0 ? "provider-height-50" : ""} cursor-default has-speciality-color-${medicalBill?.specialty?.id}`}
                          onClick={() => {
                            if (hasSettlementCheck(medicalBillsLocks[index])) {
                              return;
                            }
                            setCurrentMedicalBill(medicalBill);
                            handleMedBillShow();
                          }}
                        >
                          <td className="">{index + 1}</td>

                          <td
                            className={
                              "td-autosize position-relative speciality-color-td provider-col  actual-provider-col bg-speciality-10"
                            }
                          >
                            <div
                              className={`d-flex align-items-center sec-provider-name-2 w-100 ${medicalBill?.checkID?.length === 0 ? "top-0" : ""} ${colSpanValue === 5 ? " top-0 h-100" : "top-0 h-100"} `}
                            >
                              <div
                                className="provider-field logo-specialty-provider"
                                style={{
                                  minWidth: "25px",
                                  height: colSpanValue === 5 ? "50px" : "25px",
                                }}
                              >
                                <span
                                  className="d-flex justify-content-center fw-bold align-items-center"
                                  style={{
                                    backgroundColor: `${medicalBill?.specialty?.color}`,
                                    fontSize: "16px",
                                  }}
                                >
                                  {medicalBill?.specialty?.name[0]}
                                </span>
                              </div>
                              <p
                                className="p-l-5 p-r-5"
                                style={{
                                  color: "black",
                                  fontWeight: "600",
                                  margin: 0,
                                  textAlign: "left",
                                  ...(isWide
                                    ? { whiteSpace: "nowrap" }
                                    : {
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                      }),
                                }}
                              >
                                {medicalBill.treatment_location_name || ""}
                              </p>
                            </div>
                          </td>
                          <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width show-table-data bg-speciality-4">
                            <div className="d-flex flex-column align-items-end justify-content-center">
                              <span className="dollar-amount-value" data-value={medicalBill.amount}>
                                {currencyFormat(medicalBill.amount)}
                              </span>
                              {/* {medicalBill?.checkID?.length === 0 && (
                                <span
                                  className="dollar-amount-value"
                                  data-value={
                                    parseFloat(medicalBill.ins_paid || 0) +
                                    parseFloat(medicalBill.write_off || 0) +
                                    parseFloat(medicalBill.medpaypaip || 0) +
                                    parseFloat(medicalBill.reduction || 0) +
                                    parseFloat(medicalBill.patient_paid || 0)
                                  }
                                >
                                  {currencyFormat(
                                    -Math.abs(
                                      parseFloat(medicalBill.ins_paid || 0) +
                                        parseFloat(medicalBill.write_off || 0) +
                                        parseFloat(medicalBill.medpaypaip || 0) +
                                        parseFloat(medicalBill.reduction || 0) +
                                        parseFloat(medicalBill.patient_paid || 0)
                                    )
                                  )}
                                </span>
                              )} */}
                              {currencyFormat(
                                -Math.abs(
                                  parseFloat(medicalBill.ins_paid || 0) +
                                    parseFloat(medicalBill.write_off || 0) +
                                    parseFloat(medicalBill.medpaypaip || 0) +
                                    parseFloat(medicalBill.reduction || 0) +
                                    parseFloat(medicalBill.patient_paid || 0)
                                )
                              )}
                            </div>
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width bills-data bg-speciality-4"
                            data-value={medicalBill.amount}
                          >
                            {currencyFormat(medicalBill.amount)}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4"
                            data-value={medicalBill.ins_paid}
                          >
                            {currencyFormat(-Math.abs(medicalBill.ins_paid))}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4"
                            data-value={medicalBill.write_off}
                          >
                            {currencyFormat(-Math.abs(medicalBill.write_off))}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4"
                            data-value={medicalBill.medpaypaip}
                          >
                            {currencyFormat(-Math.abs(medicalBill.medpaypaip))}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4"
                            data-value={medicalBill.patient_paid}
                          >
                            {currencyFormat(-Math.abs(medicalBill.patient_paid))}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4"
                            data-value={medicalBill.reduction}
                          >
                            {currencyFormat(-Math.abs(medicalBill.reduction))}
                          </td>
                          <td
                            className="td-autosize text-end monospace-font dollar-amount-value med-bill-width mid-table-data bg-speciality-4"
                            data-value={
                              parseFloat(medicalBill.ins_paid || 0) +
                              parseFloat(medicalBill.write_off || 0) +
                              parseFloat(medicalBill.medpaypaip || 0) +
                              parseFloat(medicalBill.reduction || 0) +
                              parseFloat(medicalBill.patient_paid || 0)
                            }
                          >
                            {currencyFormat(
                              -Math.abs(
                                parseFloat(medicalBill.ins_paid || 0) +
                                  parseFloat(medicalBill.write_off || 0) +
                                  parseFloat(medicalBill.medpaypaip || 0) +
                                  parseFloat(medicalBill.reduction || 0) +
                                  parseFloat(medicalBill.patient_paid || 0)
                              )
                            )}
                          </td>
                          <td
                            className="text-capitalize big-n-4 bg-speciality-4"
                            onClick={(e) => e.stopPropagation()}
                          />
                          <td
                            className={`monospace-font dollar-amount-value td-autosize text-end ${!medicalBillsLocks[index].isDraftLocked && !hasSettlementCheck(medicalBillsLocks[index]) ? "cursor-pointer" : ""} bg-speciality-4`}
                            data-value={medicalBill.liens}
                          >
                            <span
                              style={{
                                paddingTop:
                                  colSpanValue === 5 && medicalBill?.checkID?.length === 0
                                    ? "2px"
                                    : "",
                              }}
                              className={`d-flex ${medicalBill?.checkID?.length === 0 ? "align-items-center h-100" : "align-items-center"} ${!medicalBillsLocks[index].isDraftLocked && !hasSettlementCheck(medicalBillsLocks[index]) ? "justify-content-between" : "justify-content-end"} position-relative center-val-div`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (hasSettlementCheck(medicalBillsLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                updateRightColumnValue(
                                  medicalBillsLocks[index].isDraftLocked,
                                  medicalBillsLocks[index].isFinalLocked,
                                  setMedicalBillsLocks,
                                  "bill-draft",
                                  medicalBill.id,
                                  medicalBillLockValues,
                                  setMedicalBillLockValues,
                                  "provider",
                                  "draft1",
                                  medicalBill.liens
                                );
                                clientProceeds.updateClientProceedsState();
                                updateMedicalBillsState();
                              }}
                            >
                              {!medicalBillsLocks[index].isDraftLocked &&
                                !hasSettlementCheck(medicalBillsLocks[index]) && (
                                  <CopyValueSettlement />
                                )}
                              {currencyFormat(medicalBill.liens)}
                            </span>
                          </td>
                          <td className="s-draft text-end">
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                if (hasSettlementCheck(medicalBillsLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                updateRightColumnValue(
                                  medicalBillsLocks[index].isDraftLocked,
                                  medicalBillsLocks[index].isFinalLocked,
                                  setMedicalBillsLocks,
                                  "bill-final",
                                  medicalBill.id,
                                  medicalBillLockValues,
                                  setMedicalBillLockValues,
                                  "provider",
                                  "final",
                                  medicalBillsLocks[index].isDraftAmount
                                );
                                updateMedicalBillsState();
                                clientProceeds.updateClientProceedsState();
                              }}
                              className={`monospace-font d-flex ${medicalBill?.checkID?.length === 0 ? "align-items-center h-100 " : "align-items-center"} justify-content-between position-relative center-val-div`}
                            >
                              <span>
                                {!hasSettlementCheck(medicalBillsLocks[index]) && (
                                  <img
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDraftLockChange(medicalBill.id, "medical_bills", e);
                                    }}
                                    id="lock-image"
                                    className="ic ic-15"
                                    src={
                                      medicalBillsLocks[index].isDraftLocked
                                        ? draftLocked
                                        : unlocked
                                    }
                                    alt="lock-icon"
                                    style={{ cursor: "pointer" }}
                                  />
                                )}
                              </span>
                              <SettlementCurrencyInput
                                id="lock-input"
                                className={`${medicalBillsLocks[index].isDraftLocked && !medicalBillsLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font bill-draft-${medicalBill.id} text-end bill-draft dollar-amount-value ${medicalBillsLocks[index].isDraftLocked ? "locked-input" : "unlock-input"}`}
                                value={medicalBill.draft1}
                                readOnly={
                                  medicalBillsLocks[index].isDraftLocked ||
                                  hasSettlementCheck(medicalBillsLocks[index])
                                }
                                onClick={(e) => {
                                  if (hasSettlementCheck(medicalBillsLocks[index])) {
                                    handleCheckedRowClick(e);
                                    return;
                                  }
                                  e.target.focus();
                                }}
                                onLocalChange={({ dataValue }) => {
                                  if (hasSettlementCheck(medicalBillsLocks[index])) return;
                                  setMedicalBillsLocks((prevStates) =>
                                    prevStates.map((row) =>
                                      row.id === medicalBill?.id
                                        ? { ...row, isDraftAmount: dataValue }
                                        : row
                                    )
                                  );
                                  const sum = getSettlementCurrencyInputSum("bill-draft");
                                  setMedicalBillLockValues((prevValues) => [sum, prevValues[1]]);
                                }}
                                onDebouncedCommit={async ({ submitValue }) => {
                                  if (hasSettlementCheck(medicalBillsLocks[index])) return;
                                  await updateLockSettleAmount(
                                    medicalBill.id,
                                    "provider",
                                    "draft1",
                                    submitValue
                                  );
                                  clientProceeds.updateClientProceedsState();
                                }}
                                onMouseEnter={(e) => {
                                  if (
                                    medicalBillsLocks[index].isDraftLocked &&
                                    !medicalBillsLocks[index].isFinalLocked &&
                                    !hasSettlementCheck(medicalBillsLocks[index])
                                  ) {
                                    const container = e.currentTarget.closest(".center-val-div");
                                    const lockImg = container?.querySelector("#lock-image");
                                    const copyElement = container?.querySelector(
                                      ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                    );
                                    if (lockImg) {
                                      lockImg.style.opacity = 0;
                                      lockImg.style.zIndex = 0;
                                    }
                                    if (copyElement) {
                                      copyElement.style.opacity = 1;
                                      copyElement.style.zIndex = 1;
                                      copyElement.style.cursor = "pointer";
                                      copyElement.style.display = "flex";
                                    }
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (
                                    medicalBillsLocks[index].isDraftLocked &&
                                    !medicalBillsLocks[index].isFinalLocked &&
                                    !hasSettlementCheck(medicalBillsLocks[index])
                                  ) {
                                    const container = e.currentTarget.closest(".center-val-div");
                                    const lockImg = container?.querySelector("#lock-image");
                                    const copyElement = container?.querySelector(
                                      ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                    );
                                    if (lockImg) {
                                      lockImg.style.opacity = 1;
                                      lockImg.style.zIndex = 1;
                                    }
                                    if (copyElement) {
                                      copyElement.style.opacity = 0;
                                      copyElement.style.zIndex = 0;
                                      copyElement.style.cursor = "initial";
                                      copyElement.style.display = "none";
                                    }
                                  }
                                }}
                                style={{ zIndex: 2 }}
                              />
                              {medicalBillsLocks[index].isDraftLocked &&
                                !medicalBillsLocks[index].isFinalLocked &&
                                !hasSettlementCheck(medicalBillsLocks[index]) && (
                                  <CopyValueSettlement draft={true} />
                                )}
                            </div>
                          </td>
                          <td className="s-final">
                            <div
                              // onMouseEnter={() =>
                              //   setIsHovered({
                              //     id: medicalBill?.id,
                              //     value: true,
                              //   })
                              // }
                              // onMouseLeave={() =>
                              //   setIsHovered({
                              //     id: medicalBill?.id,
                              //     value: false,
                              //   })
                              // }
                              className={`monospace-font d-flex ${medicalBill?.checkID?.length === 0 ? "align-items-center h-100" : "align-items-center"} justify-content-between position-relative center-val-div`}
                            >
                              <span>
                                {!hasSettlementCheck(medicalBillsLocks[index]) && (
                                  <img
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleFinalLockChange(medicalBill.id, "medical_bills", e);
                                    }}
                                    id="lock-image"
                                    className={`ic ic-15 ${medicalBillsLocks[index].checkID[0]?.check_sent ? "invisible" : ""} `}
                                    src={
                                      medicalBillsLocks[index].isFinalLocked
                                        ? medicalBillsLocks[index].checkID[0]?.check_sent
                                          ? lockedGrey
                                          : addCheck
                                        : medicalBillsLocks[index].checkID[0]?.check_sent
                                          ? unlockedGrey
                                          : unlocked
                                    }
                                    alt="lock-icon"
                                    style={{ cursor: "pointer" }}
                                    // onMouseEnter={() =>
                                    //   setIsHovered({
                                    //     id: medicalBill?.id,
                                    //     value: false,
                                    //   })
                                    // }
                                    // onMouseLeave={() =>
                                    //   setIsHovered({
                                    //     id: medicalBill?.id,
                                    //     value: true,
                                    //   })
                                    // }
                                  />
                                )}
                              </span>
                              <SettlementCurrencyInput
                                id="lock-input"
                                className={`${!hasSettlementCheck(medicalBillsLocks[index]) && medicalBillsLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font bill-final-${medicalBill.id} text-end bill-final dollar-amount-value ${medicalBillsLocks[index].isFinalLocked ? "locked-input" : "unlock-input"}`}
                                value={medicalBill.final}
                                readOnly={
                                  medicalBillsLocks[index].isFinalLocked ||
                                  hasSettlementCheck(medicalBillsLocks[index])
                                }
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  e.target.focus();
                                  if (hasSettlementCheck(medicalBillsLocks[index])) {
                                    handleCheckedRowClick(e);
                                    return;
                                  }
                                }}
                                onLocalChange={({ dataValue }) => {
                                  if (hasSettlementCheck(medicalBillsLocks[index])) return;
                                  setMedicalBillsLocks((prevStates) =>
                                    prevStates.map((row) =>
                                      row.id === medicalBill.id
                                        ? { ...row, isFinalAmount: dataValue }
                                        : row
                                    )
                                  );
                                  const sum = getSettlementCurrencyInputSum("bill-final");
                                  setMedicalBillLockValues((prevValues) => [prevValues[0], sum]);
                                }}
                                onDebouncedCommit={async ({ submitValue }) => {
                                  if (hasSettlementCheck(medicalBillsLocks[index])) return;
                                  await updateLockSettleAmount(
                                    medicalBill.id,
                                    "provider",
                                    "final",
                                    submitValue
                                  );
                                  clientProceeds.updateClientProceedsState();
                                }}
                              />
                              {!hasSettlementCheck(medicalBillsLocks[index]) &&
                                medicalBillsLocks[index].isFinalLocked && (
                                  <CopyValueSettlement draft={true} final={true} />
                                )}
                            </div>
                          </td>
                          <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                            <ChequeUpload
                              entity={medicalBill}
                              panel={"med-bills"}
                              pageId={page_id_click_record}
                              documentType="verify"
                              updateStates={updateMedicalBillsState}
                              handleNoCheckShow={handleNoCheckShow}
                            />
                          </td>
                          <td
                            className="td-autosize  text-center"
                            onClick={(e) => e.stopPropagation()}
                          >
                            {/* {!hasSettlementCheck(medicalBillsLocks[index]) && */}
                            {medicalBillsLocks[index].isFinalLocked &&
                              hasNonZeroSettlementAmount(
                                medicalBillsLocks[index].isFinalAmount
                              ) && (
                                <div className="d-flex align-items-center justify-content-center">
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (medicalBillsLocks[index].isFinalLocked) {
                                        setCurrentMedicalBill({
                                          ...medicalBill,
                                          final: medicalBillsLocks[index].isFinalAmount,
                                        });
                                        setCheckRequestModal(true);
                                      }
                                    }}
                                    className="settle-check-request-btn btn"
                                    id="nomargin"
                                    style={{
                                      color: "white",
                                      fontWeight: "600",
                                      background: "#009900",
                                    }}
                                  >
                                    <p className={"font-weight-semibold"}>Request Check</p>
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                        {medicalBill?.checkID?.length > 0 &&
                          medicalBill?.checkID?.map((check) => {
                            return (
                              <tr
                                className={`cursor-default has-speciality-color-${medicalBill?.specialty?.id}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setCurrentMedicalBill(medicalBill);
                                  setCheck(check);
                                  showEditCostModal(true);
                                }}
                              >
                                <td className="" />
                                <td className="td-autosize speciality-color-td provider-col bg-speciality-10">
                                  <div
                                    className="bg-speciality"
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                    }}
                                  >
                                    {/*  */}
                                  </div>
                                </td>
                                <td
                                  className="td-autosize text-end monospace-font dollar-amount-value med-bill-width show-table-data bg-speciality-4"
                                  data-value={
                                    parseFloat(medicalBill.ins_paid || 0) +
                                    parseFloat(medicalBill.write_off || 0) +
                                    parseFloat(medicalBill.medpaypaip || 0) +
                                    parseFloat(medicalBill.reduction || 0) +
                                    parseFloat(medicalBill.patient_paid || 0)
                                  }
                                >
                                  {/* {index === 0 &&
                                    currencyFormat(
                                      -Math.abs(
                                        parseFloat(medicalBill.ins_paid || 0) +
                                          parseFloat(medicalBill.write_off || 0) +
                                          parseFloat(medicalBill.medpaypaip || 0) +
                                          parseFloat(medicalBill.reduction || 0) +
                                          parseFloat(medicalBill.patient_paid || 0)
                                      )
                                    )} */}
                                </td>
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width bills-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data bg-speciality-4" />
                                <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width mid-table-data bg-speciality-4" />
                                <td className="text-capitalize big-n-4 bg-speciality-4" />
                                <td className="monospace-font dollar-amount-value td-autosize text-end bg-speciality-4" />
                                <td className="s-draft text-end" />
                                <td
                                  className="s-final text-end monospace-font"
                                  data-value={check?.amount || 0.0}
                                >
                                  <span style={{ marginRight: "2px" }}>
                                    {currencyFormat(check?.amount)}
                                  </span>
                                </td>
                                <td className="s-verify">
                                  <ChequeUpload
                                    entity={{
                                      id: medicalBill?.id,
                                      checkID: check,
                                    }}
                                    panel={"other"}
                                    pageId={page_id_click_record}
                                    documentType="verify"
                                    updateStates={updateMedicalBillsState}
                                    handleNoCheckShow={handleNoCheckShow}
                                  />
                                </td>
                                <td
                                  className="td-autosize text-center"
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="d-flex justify-content-center">
                                    <SettlementCheckDetails
                                      entity={{
                                        id: medicalBill?.id,
                                        checkID: check,
                                      }}
                                      check={check}
                                      pageId={page_id_click_record}
                                      updateStates={updateMedicalBillsState}
                                      handleNoCheckShow={handleNoCheckShow}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </React.Fragment>
                    ))}
                  {medicalBills.length > 0 && (
                    <tr className="cursor-default">
                      <td className="" />
                      <td className="td-autosize provider-col text-end">
                        {" "}
                        <span className="d-flex align-items-start justify-content-end">
                          Total:{" "}
                        </span>
                      </td>
                      <td className="td-autosize text-end monospace-font dollar-amount-value med-bill-width show-table-data bg-speciality-4">
                        <div className="d-flex flex-column align-items-end justify-content-center">
                          <span
                            data-value={
                              medicalBills?.reduce(
                                (acc, bill) => parseFloat(bill?.amount) + parseFloat(acc),
                                0
                              ) || 0.0
                            }
                          >
                            {" "}
                            {currencyFormat(
                              medicalBills?.reduce(
                                (acc, bill) => parseFloat(bill?.amount) + parseFloat(acc),
                                0
                              )
                            )}
                          </span>
                          <span
                            data-value={
                              medicalBills.reduce(
                                (acc, bill) =>
                                  parseFloat(acc) +
                                  parseFloat(bill.ins_paid || 0) +
                                  parseFloat(bill.write_off || 0) +
                                  parseFloat(bill.medpaypaip || 0) +
                                  parseFloat(bill.reduction || 0) +
                                  parseFloat(bill.patient_paid || 0),
                                0
                              ) || 0.0
                            }
                          >
                            {currencyFormat(
                              medicalBills.reduce(
                                (acc, bill) =>
                                  parseFloat(acc) +
                                  parseFloat(bill.ins_paid || 0) +
                                  parseFloat(bill.write_off || 0) +
                                  parseFloat(bill.medpaypaip || 0) +
                                  parseFloat(bill.reduction || 0) +
                                  parseFloat(bill.patient_paid || 0),
                                0
                              )
                            )}
                          </span>
                        </div>
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width bills-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.amount) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {" "}
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.amount) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.ins_paid) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {" "}
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.ins_paid) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.write_off) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {" "}
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.write_off) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.medpaypaip) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {" "}
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.medpaypaip) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.patient_paid) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {" "}
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.patient_paid) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width hide-table-data"
                        data-value={
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.reduction) + parseFloat(acc),
                            0
                          ) || 0.0
                        }
                      >
                        {currencyFormat(
                          medicalBills?.reduce(
                            (acc, bill) => parseFloat(bill?.reduction) + parseFloat(acc),
                            0
                          )
                        )}
                      </td>
                      <td
                        className="td-autosize text-end monospace-font dollar-amount-value med-bill-width mid-table-data"
                        data-value={
                          medicalBills.reduce(
                            (acc, bill) =>
                              parseFloat(acc) +
                              parseFloat(bill.ins_paid || 0) +
                              parseFloat(bill.write_off || 0) +
                              parseFloat(bill.medpaypaip || 0) +
                              parseFloat(bill.reduction || 0) +
                              parseFloat(bill.patient_paid || 0),
                            0
                          ) || 0.0
                        }
                      >
                        {currencyFormat(
                          medicalBills.reduce(
                            (acc, bill) =>
                              parseFloat(acc) +
                              parseFloat(bill.ins_paid || 0) +
                              parseFloat(bill.write_off || 0) +
                              parseFloat(bill.medpaypaip || 0) +
                              parseFloat(bill.reduction || 0) +
                              parseFloat(bill.patient_paid || 0),
                            0
                          )
                        )}
                      </td>
                      <td className="text-capitalize big-n-4" />
                      <td className="height-25 text-capitalize text-end bill-total-td">
                        <div
                          className={`${colSpanValue === 5 ? "d-flex align-items-start h-100 justify-content-end" : "d-flex align-items-start justify-content-end"}`}
                        >
                          <span className="whitespace-SETTLE primary-clr-25">
                            Total Liens:&nbsp;
                          </span>
                          <p
                            className="monospace-font text-end fw-bold dollar-amount-value"
                            data-value={medicalBillFinalAmount || 0.0}
                          >
                            {currencyFormat(medicalBillFinalAmount || 0.0)}
                          </p>
                        </div>
                      </td>
                      <td
                        className="s-draft monospace-font text-end"
                        data-value={medicalBillLockValues[0]}
                      >
                        <span
                          style={{ paddingRight: "2px" }}
                          data-value={medicalBillLockValues[0] || 0.0}
                          className={`${colSpanValue === 5 ? "d-flex align-items-start h-100 justify-content-end" : "d-flex align-items-start justify-content-end"} dollar-amount-value`}
                        >
                          {currencyFormat(medicalBillLockValues[0])}
                        </span>
                      </td>
                      <td
                        className="s-final monospace-font text-end"
                        data-value={medicalBillLockValues[1]}
                      >
                        <span
                          style={{ paddingRight: "2px" }}
                          data-value={medicalBillLockValues[1] || 0.0}
                          className={`${colSpanValue === 5 ? "d-flex align-items-start h-100 justify-content-end" : "d-flex align-items-start justify-content-end"} dollar-amount-value`}
                        >
                          {currencyFormat(medicalBillLockValues[1])}
                        </span>
                      </td>
                      <td className="s-verify" />
                      <td className="td-autosize" />
                    </tr>
                  )}
                </>
              </tbody>
            </table>
          </div>
        </div>
      )}
      {insuranceLiensObj?.insuranceLiens && insuranceLiensObj?.insuranceLiens?.length > 0 && (
        <InsuranceLiensTable
          insuranceLiensObj={insuranceLiensObj}
          clientProceeds={clientProceeds}
          settlementObjProps={settlementObjProps}
        />
      )}
      {otherLiensObj?.otherLiens && otherLiensObj?.otherLiens?.length > 0 && (
        <OtherLiensTable
          otherLiensObj={otherLiensObj}
          clientProceeds={clientProceeds}
          settlementObjProps={settlementObjProps}
        />
      )}

      {loans && loans?.length > 0 && (
        <div className="m-t-5 m-b-5">
          <SectionActionBar sectionName={"LOANS AND ADVANCES"} />
          <div className="table--no-card rounded-0 border-0 w-100">
            <table className="table table-borderless table-striped table-earning settlement-table">
              {loans?.length > 0 && (
                <thead>
                  <tr id="settle-tb-header" className="settle-t-5 cursor-default">
                    <th className="" />
                    <th className="td-autosize text-start first-col">Company</th>
                    <th className="td-autosize text-center">Account</th>
                    <th className="td-autosize text-center med-bill-width">Loan</th>
                    <th className="td-autosize text-center">Disbursed</th>
                    <th className="td-autosize text-center med-bill-width">Payoff</th>
                    <th className="td-autosize text-center">Verified</th>
                    <th className="" />
                    <th
                      className={`text-end td-autosize ${loansLocks?.some((lock) => !lock.isDraftLocked) ? "cursor-pointer" : ""}`}
                      // style={{ color: "var(--primary-25) !important" }}
                      onClick={() => {
                        const draftLockCheck = loansLocks?.some(
                          (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                        );
                        if (draftLockCheck) {
                          loansLocks?.forEach((loan, index) => {
                            if (!loan.isDraftLocked && !hasSettlementCheck(loan)) {
                              updateRightColumnValue(
                                loan.isDraftLocked,
                                loan.isFinalLocked,
                                setLoansLocks,
                                "loan-draft",
                                loan.id,
                                loansLockValues,
                                setLoansLockValues,
                                "loans",
                                "draft1",
                                loans[index].final_amount
                              );
                            }
                          });
                          updateLoansState();
                          clientProceeds.updateClientProceedsState();
                        }
                      }}
                    >
                      <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                        {loansLocks?.some(
                          (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                        ) && <CopyValueSettlement />}
                        Amount
                      </span>
                    </th>
                    <th
                      className={`s-draft text-end ${loansLocks?.some((lock) => lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                      style={{ color: "var(--primary-25) !important" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        const finalLockCheck = loansLocks?.some(
                          (lock) =>
                            lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                        );

                        if (finalLockCheck) {
                          loansLocks?.forEach((loan) => {
                            if (
                              loan.isDraftLocked &&
                              !loan.isFinalLocked &&
                              !hasSettlementCheck(loan)
                            ) {
                              updateRightColumnValue(
                                loan.isDraftLocked,
                                loan.isFinalLocked,
                                setLoansLocks,
                                "loan-final",
                                loan.id,
                                loansLockValues,
                                setLoansLockValues,
                                "loans",
                                "final",
                                loan.isDraftAmount
                              );
                            }
                          });
                          clientProceeds.updateClientProceedsState();
                        }
                      }}
                    >
                      <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                        <div className="d-flex align-items-center position-relative">
                          <img
                            className="invisible ic ic-19"
                            id="lock-image"
                            src={unlocked}
                            alt="lock-icon"
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="lock-image"
                            className="ic ic-19 lock-icon"
                            src={unlocked}
                            alt="lock-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllLoans("draft1", "false");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="unlock-image"
                            className="ic ic-19 lock-icon"
                            alt="lock-icon"
                            src={draftLocked}
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllLoans("draft1", "true");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                        <span
                          className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                          style={{ paddingRight: "2px" }}
                        >
                          {loansLocks?.some(
                            (lock) =>
                              lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                          ) && <CopyValueSettlement />}
                          <span className="position-absolute right-0">Draft</span>
                        </span>
                      </div>
                    </th>
                    <th
                      className="s-final text-end"
                      style={{ color: "var(--primary-25) !important" }}
                    >
                      <div className="d-flex justify-content-between align-items-center height-25">
                        <div className="d-flex align-items-center">
                          <img
                            className="invisible ic ic-19"
                            id="lock-image"
                            src={unlocked}
                            alt="lock-icon"
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="lock-image"
                            className="ic ic-19"
                            src={unlocked}
                            alt="lock-icon"
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllLoans("final", "false");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <img
                            id="unlock-image"
                            className="ic ic-19"
                            alt="lock-icon"
                            src={locked}
                            onClick={(e) => {
                              e.stopPropagation();
                              lockAllLoans("final", "true");
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                        <span style={{ paddingRight: "2px" }}>Final</span>
                      </div>
                    </th>
                    <th className="s-verify" />
                    <th
                      className="td-autosize check-request--btn-settle text-center"
                      style={{ color: "var(--primary-25) !important" }}
                    >
                      Check
                    </th>
                  </tr>
                </thead>
              )}
              <tbody id="body-table">
                {loans?.length === 0 && (
                  <tr id="cost-settle-row" className="add-btn-row cursor-default padding-tr-0">
                    <td className="text=center cursor-pointer" colSpan={13}>
                      <SettlementEmptyMessage
                        name="LOANS"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowSettlementPopup2(true);
                        }}
                      />
                    </td>
                  </tr>
                )}
                {loans?.length > 0 &&
                  loans?.map((loan, index) => (
                    <tr
                      key={index}
                      className="cursor-default"
                      onClick={() => {
                        setCurrentLoan(loan);
                        handleLoanShow();
                      }}
                    >
                      <td className="">{index + 1}</td>
                      <td className="td-autosize text-start first-col">{loan?.loan_company}</td>
                      <td className="td-autosize text-center">{loan?.account_number}</td>
                      <td
                        className="td-autosize text-end td-autosize med-bill-width monospace-font dollar-amount-value"
                        data-value={loan?.current_amount_verified}
                      >
                        {currencyFormat(loan?.current_amount_verified)}
                      </td>
                      <td className="td-autosize text-center">
                        {formatCalendarDate(loan?.date_disbursed)}
                      </td>
                      <td
                        className="td-autosize monospace-font text-end dollar-amount-value"
                        data-value={loan?.final_amount}
                      >
                        {currencyFormat(loan?.final_amount)}
                      </td>
                      <td className="td-autosize text-center">
                        {formatCalendarDate(loan?.date_verified)}
                      </td>
                      <td className="" onClick={(e) => e.stopPropagation()} />
                      <td
                        className="text-end monospace-font dollar-amount-value td-autosize"
                        data-value={loan?.final_payoff}
                      >
                        <span
                          className={`d-flex align-items-center ${!loansLocks[index].isDraftLocked && !hasSettlementCheck(loansLocks[index]) ? "justify-content-between" : "justify-content-end"} align-items-center position-relative center-val-div`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasSettlementCheck(loansLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                            updateRightColumnValue(
                              loansLocks[index].isDraftLocked,
                              loansLocks[index].isFinalLocked,
                              setLoansLocks,
                              "loan-draft",
                              loan.id,
                              loansLockValues,
                              setLoansLockValues,
                              "loans",
                              "draft1",
                              loan?.final_payoff
                            );
                            updateLoansState();
                            clientProceeds.updateClientProceedsState();
                          }}
                        >
                          {!loansLocks[index].isDraftLocked &&
                            !hasSettlementCheck(loansLocks[index]) && <CopyValueSettlement />}
                          {currencyFormat(loan?.final_payoff)}
                        </span>
                      </td>
                      <td
                        className="s-draft text-end"
                        onClick={(e) => {
                          e.stopPropagation(); //
                          if (hasSettlementCheck(loansLocks[index])) {
                            handleCheckedRowClick(e);
                            return;
                          }
                          updateRightColumnValue(
                            loansLocks[index].isDraftLocked,
                            loansLocks[index].isFinalLocked,
                            setLoansLocks,
                            "loan-final",
                            loan.id,
                            loansLockValues,
                            setLoansLockValues,
                            "loans",
                            "final",
                            loansLocks[index].isDraftAmount
                          );
                          updateLoansState();
                          clientProceeds.updateClientProceedsState();
                        }}
                      >
                        <div className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div">
                          <span>
                            {!hasSettlementCheck(loansLocks[index]) && (
                              <img
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDraftLockChange(loan.id, "loans", e);
                                }}
                                id="lock-image"
                                className="ic ic-15"
                                src={loansLocks[index].isDraftLocked ? draftLocked : unlocked}
                                alt="lock-icon"
                                style={{ cursor: "pointer" }}
                              />
                            )}
                          </span>
                          <SettlementCurrencyInput
                            id="lock-input"
                            className={`${loansLocks[index].isDraftLocked && !loansLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font text-end loan-draft-${loan.id} loan-draft dollar-amount-value ${loansLocks[index].isDraftLocked ? "locked-input" : "unlock-input"}`}
                            value={loan.draft1}
                            readOnly={
                              loansLocks[index].isDraftLocked ||
                              hasSettlementCheck(loansLocks[index])
                            }
                            onClick={(e) => {
                              if (hasSettlementCheck(loansLocks[index])) {
                                handleCheckedRowClick(e);
                                return;
                              }
                              e.target.focus();
                            }}
                            onLocalChange={({ dataValue }) => {
                              if (hasSettlementCheck(loansLocks[index])) return;
                              setLoansLocks((prevStates) =>
                                prevStates.map((row) =>
                                  row.id === loan?.id ? { ...row, isDraftAmount: dataValue } : row
                                )
                              );
                              const sum = getSettlementCurrencyInputSum("loan-draft");
                              setLoansLockValues((prevValues) => [sum, prevValues[1]]);
                            }}
                            onDebouncedCommit={async ({ submitValue }) => {
                              if (hasSettlementCheck(loansLocks[index])) return;
                              await updateLockSettleAmount(loan.id, "loans", "draft1", submitValue);
                              clientProceeds.updateClientProceedsState();
                            }}
                            onMouseEnter={(e) => {
                              if (
                                loansLocks[index].isDraftLocked &&
                                !loansLocks[index].isFinalLocked &&
                                !hasSettlementCheck(loansLocks[index])
                              ) {
                                const container = e.currentTarget.closest(".center-val-div");
                                const lockImg = container?.querySelector("#lock-image");
                                const copyElement = container?.querySelector(
                                  ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                );
                                if (lockImg) {
                                  lockImg.style.opacity = 0;
                                  lockImg.style.zIndex = 0;
                                }
                                if (copyElement) {
                                  copyElement.style.opacity = 1;
                                  copyElement.style.zIndex = 1;
                                  copyElement.style.cursor = "pointer";
                                  copyElement.style.display = "flex";
                                }
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (
                                loansLocks[index].isDraftLocked &&
                                !loansLocks[index].isFinalLocked &&
                                !hasSettlementCheck(loansLocks[index])
                              ) {
                                const container = e.currentTarget.closest(".center-val-div");
                                const lockImg = container?.querySelector("#lock-image");
                                const copyElement = container?.querySelector(
                                  ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                );
                                if (lockImg) {
                                  lockImg.style.opacity = 1;
                                  lockImg.style.zIndex = 1;
                                }
                                if (copyElement) {
                                  copyElement.style.opacity = 0;
                                  copyElement.style.zIndex = 0;
                                  copyElement.style.cursor = "initial";
                                  copyElement.style.display = "none";
                                }
                              }
                            }}
                            style={{ zIndex: 2 }}
                          />
                          {loansLocks[index].isDraftLocked &&
                            !loansLocks[index].isFinalLocked &&
                            !hasSettlementCheck(loansLocks[index]) && (
                              <CopyValueSettlement draft={true} />
                            )}
                        </div>
                      </td>
                      <td className="s-final">
                        <div
                          // onMouseEnter={() => setIsHovered({ id: loan?.id, value: true })}
                          // onMouseLeave={() => setIsHovered({ id: loan?.id, value: false })}
                          className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                        >
                          <span>
                            {!hasSettlementCheck(loansLocks[index]) && (
                              <img
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleFinalLockChange(loan.id, "loans", e);
                                }}
                                id="lock-image"
                                className={`ic ic-15 ${loansLocks[index].checkID?.check_sent ? "invisible" : ""} `}
                                src={
                                  loansLocks[index].isFinalLocked
                                    ? loansLocks[index].checkID?.check_sent
                                      ? lockedGrey
                                      : locked
                                    : loansLocks[index].checkID?.check_sent
                                      ? unlockedGrey
                                      : unlocked
                                }
                                alt="lock-icon"
                                style={{ cursor: "pointer" }}
                                // onMouseEnter={() => setIsHovered({ id: loan?.id, value: false })}
                                // onMouseLeave={() => setIsHovered({ id: loan?.id, value: true })}
                              />
                            )}
                          </span>
                          <SettlementCurrencyInput
                            id="lock-input"
                            className={`${!loansLocks[index].checkID && loansLocks[index].isFinalLocked ? "cursor-pointer" : ""}  monospace-font text-end loan-final-${loan.id} loan-final dollar-amount-value ${loansLocks[index].isFinalLocked ? "locked-input" : "unlock-input"}`}
                            value={loan.final}
                            readOnly={
                              loansLocks[index].isFinalLocked ||
                              hasSettlementCheck(loansLocks[index])
                            }
                            onClick={async (e) => {
                              e.stopPropagation();
                              e.target.focus();
                              if (hasSettlementCheck(loansLocks[index])) {
                                handleCheckedRowClick(e);
                                return;
                              }
                            }}
                            onLocalChange={({ dataValue }) => {
                              if (hasSettlementCheck(loansLocks[index])) return;
                              setLoansLocks((prevStates) =>
                                prevStates.map((row) =>
                                  row.id === loan?.id ? { ...row, isFinalAmount: dataValue } : row
                                )
                              );
                              const sum = getSettlementCurrencyInputSum("loan-final");
                              setLoansLockValues((prevValues) => [prevValues[0], sum]);
                            }}
                            onDebouncedCommit={async ({ submitValue }) => {
                              if (hasSettlementCheck(loansLocks[index])) return;
                              await updateLockSettleAmount(loan.id, "loans", "final", submitValue);
                              clientProceeds.updateClientProceedsState();
                            }}
                          />
                        </div>
                      </td>
                      <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                        <ChequeUpload
                          entity={loan}
                          panel={"loan"}
                          pageId={page_id_click_record}
                          documentType="verify"
                          updateStates={updateLoansState}
                          handleNoCheckShow={handleNoCheckShow}
                        />
                      </td>
                      <td className="td-autosize text-center " onClick={(e) => e.stopPropagation()}>
                        <div
                          className={`${loansLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center"} `}
                        >
                          {!loansLocks[index].checkID &&
                          loansLocks[index].isFinalLocked &&
                          hasNonZeroSettlementAmount(loansLocks[index].isFinalAmount) ? (
                            <div className="d-flex align-items-center justify-content-center">
                              <div
                                className="settle-check-request-btn btn"
                                id="nomargin"
                                style={{
                                  color: "white",
                                  fontWeight: "600",
                                  background: "#009900",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (loansLocks[index].isFinalLocked) {
                                    setCurrentLoan({
                                      ...loan,
                                      final: loansLocks[index].isFinalAmount,
                                    });
                                    setLoanCheckRequestModal(true);
                                  }
                                }}
                              >
                                <p className={"font-weight-semibold"}>Request Check</p>
                              </div>
                            </div>
                          ) : (
                            <SettlementCheckDetails
                              entity={loan}
                              check={loansLocks[index].checkID}
                              pageId={page_id_click_record}
                              updateStates={updateLoansState}
                              handleNoCheckShow={handleNoCheckShow}
                            />
                          )}
                        </div>
                      </td>
                      {/* <td className="td-autosize d-flex check-request-td text-center" onClick={(e) => e.stopPropagation()}>
                                        <div className={`${ loansLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center" } `}>
                                            {
                                                ((!loansLocks[index].checkID && loansLocks[index].isFinalLocked && hasNonZeroSettlementAmount(loansLocks[index].isFinalAmount))) ? <div className="settle-check-request-btn btn" id="nomargin">
                                                    
                                                </div>
                                                    :
                                                    <>
                                                        <div className='d-flex justify-content-center'>
                                                            <span>{loansLocks[index].checkID?.cheque_date ? '' : loansLocks[index].checkID?.date_check_requested && <span className='requested-btn'>Requested:&nbsp;</span>}</span>
                                                            
                                                            <span>{formatCalendarDate(loansLocks[index].checkID?.cheque_date || loansLocks[index].checkID?.date_check_requested || '')}</span>
                                                        </div>
                                                    </>
                                            }
                                            {loansLocks[index]?.checkID?.cheque_number && <span className='d-inline-block check-number'>{loansLocks[index]?.checkID?.cheque_number}</span>}
                                            {loansLocks[index]?.checkID?.cheque_number && <ChequeUpload entity={loan} panel={"loan"} pageId={page_id_click_record} documentType="check_as_sent" updateStates={updateLoansState} handleNoCheckShow={handleNoCheckShow} />}
                                        </div>
                                    </td> */}
                    </tr>
                  ))}
                {loans?.length > 0 && (
                  <tr className="cursor-default">
                    <td />
                    <td className="height-25 text-capitalize text-end" colSpan={8}>
                      <span className="whitespace-SETTLE primary-clr-25 p-r-5">Total Loans:</span>
                      <p
                        className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                        data-value={loansFinalAmount || 0.0}
                      >
                        {currencyFormat(loansFinalAmount || 0.0)}
                      </p>
                    </td>
                    <td
                      className="s-draft monospace-font text-end"
                      data-value={loansLockValues[0] || 0.0}
                    >
                      <span
                        style={{ paddingRight: "2px" }}
                        className="dollar-amount-value"
                        data-value={loansLockValues[0] || 0.0}
                      >
                        {" "}
                        {currencyFormat(loansLockValues[0] || 0.0)}
                      </span>
                    </td>
                    <td
                      className="s-final monospace-font text-end"
                      data-value={loansLockValues[1] || 0.0}
                    >
                      <span
                        style={{ paddingRight: "2px" }}
                        className="dollar-amount-value"
                        data-value={loansLockValues[1] || 0.0}
                      >
                        {" "}
                        {currencyFormat(loansLockValues[1] || 0.0)}
                      </span>
                    </td>
                    <td className="s-verify" />
                    <td className="td-autosize" />
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {firmCounselObj?.firmCounselingLiens && firmCounselObj?.firmCounselingLiens?.length > 0 && (
        <FirmCounselingLiensTable
          firmCounselObj={firmCounselObj}
          settlementObjProps={settlementObjProps}
          clientProceeds={clientProceeds}
        />
      )}
      {opposingCounselObj?.opposingCounselingLiens &&
        opposingCounselObj?.opposingCounselingLiens?.length > 0 && (
          <OpposingCounselingLiensTable
            opposingCounselObj={opposingCounselObj}
            settlementObjProps={settlementObjProps}
            clientProceeds={clientProceeds}
          />
        )}
      {clientProceeds?.checks && clientProceeds?.checks?.length > 0 && (
        <ClientProceeds clientProceeds={clientProceeds} settlementObjProps={settlementObjProps} />
      )}
      {((offersObj?.offers && offersObj?.offers?.length > 0) ||
        (feesObj?.fees && feesObj?.fees?.length > 0) ||
        (medicalBills && medicalBills?.length > 0) ||
        (insuranceLiensObj?.insuranceLiens && insuranceLiensObj?.insuranceLiens?.length > 0) ||
        (otherLiensObj?.otherLiens && otherLiensObj?.otherLiens?.length > 0) ||
        (loans && loans?.length > 0) ||
        (clientProceeds?.checks && clientProceeds?.checks?.length > 0)) && (
        <div className="m-b-5 m-t-5">
          <tr className="height-25 total-settle-row cursor-default">
            <td className="height-25 text-capitalize text-end big-n-5 primary-clr-25" colSpan={8}>
              Total:
            </td>
            <td className="td-autosize height-25 monospace-font text-end fw-bold dollar-amount-value">
              {currencyFormat(
                parseFloat(offersObj.offerAcceptedAmount || 0.0) -
                  ((clientProceeds.checks?.length > 0
                    ? clientProceeds.checks.reduce(
                        (total, check) => total + parseFloat(check?.amount || 0),
                        0
                      )
                    : 0.0) +
                    parseFloat(feesObj.feesFinalAmount || 0.0) +
                    parseFloat(costsObj.costFinalAmount || 0.0) +
                    parseFloat(medicalBillFinalAmount || 0.0) +
                    parseFloat(insuranceLiensObj.insuranceLienFinalAmount || 0.0) +
                    parseFloat(otherLiensObj.otherLienFinalAmount || 0.0) +
                    parseFloat(opposingCounselObj.opposingCounselingLienFinalAmount || 0.0) +
                    parseFloat(firmCounselObj.firmCounselingLienFinalAmount || 0.0) +
                    parseFloat(loansFinalAmount || 0.0)) || 0.0
              )}
            </td>

            <td className="s-draft monospace-font text-end dollar-amount-value">
              <span style={{ paddingRight: "2px" }}>
                {currencyFormat(
                  parseFloat(offersObj.acceptedDraftnFinalValues[0] || 0.0) -
                    // parseFloat(clientProceeds.clientProceed?.balance_record.draft1 || 0.0) +
                    ((clientProceeds.checks?.length > 0
                      ? clientProceeds.checks.reduce(
                          (total, check) => total + parseFloat(check?.draft1 || 0),
                          0
                        )
                      : 0.0) +
                      // parseFloat(clientProceeds.checksLocksValues[0]?.isDraftAmount || 0.0) +
                      parseFloat(feesObj.feesLockValues[0] || 0.0) +
                      parseFloat(costsObj.itemizedCost.chv_settle.draft1) +
                      parseFloat(medicalBillLockValues[0] || 0.0) +
                      parseFloat(insuranceLiensObj.insuranceLiensLocksValues[0] || 0.0) +
                      parseFloat(otherLiensObj.otherLiensLocksValues[0] || 0.0) +
                      parseFloat(opposingCounselObj.opposingCounselingLiensLocksValues[0] || 0.0) +
                      parseFloat(firmCounselObj.firmCounselingLiensLocksValues[0] || 0.0) +
                      parseFloat(loansLockValues[0] || 0.0)) || 0.0
                )}
              </span>
            </td>

            <td className="s-final monospace-font text-end dollar-amount-value">
              <span style={{ paddingRight: "2px" }}>
                {currencyFormat(
                  parseFloat(offersObj.acceptedDraftnFinalValues[1] || 0.0) -
                    // parseFloat(clientProceeds.clientProceed?.balance_record.final || 0.0) +
                    ((clientProceeds.checks?.length > 0
                      ? clientProceeds.checks.reduce(
                          (total, check) => total + parseFloat(check?.final || 0),
                          0
                        )
                      : 0.0) +
                      // parseFloat(clientProceeds.checksLocksValues[1] || 0.0) +
                      parseFloat(feesObj.feesLockValues[1] || 0.0) +
                      parseFloat(costsObj.itemizedCost.chv_settle.final) +
                      parseFloat(medicalBillLockValues[1] || 0.0) +
                      parseFloat(insuranceLiensObj.insuranceLiensLocksValues[1] || 0.0) +
                      parseFloat(opposingCounselObj.opposingCounselingLiensLocksValues[1] || 0.0) +
                      parseFloat(firmCounselObj.firmCounselingLiensLocksValues[1] || 0.0) +
                      parseFloat(otherLiensObj.otherLiensLocksValues[1] || 0.0) +
                      parseFloat(loansLockValues[1] || 0.0)) || 0.0
                )}
              </span>
            </td>

            <td className="s-verify" />
            <td className="td-autosize" />
          </tr>
        </div>
      )}
      {showSettlementPopup1 && (
        <GenericSettlementAddPopup
          show={showSettlementPopup1}
          handleClose={() => {
            setShowSettlementPopup1(false);
          }}
          _initialLabel={"Medical Provider Lien or Expense"}
          {...settlementObjProps}
        />
      )}
      {showSettlementPopup2 && (
        <GenericSettlementAddPopup
          show={showSettlementPopup2}
          handleClose={() => {
            setShowSettlementPopup2(false);
          }}
          _initialLabel={"Loan and Advance"}
          {...settlementObjProps}
        />
      )}
      {showMedBillModal && (
        <EditMedicalBill
          show={showMedBillModal}
          handleClose={handleMedBillClose}
          medicalBill={currentMedicalBill}
          refetchAll={updateMedicalBillsState}
          specialitie={currentMedicalBill?.specialty}
          tfData={currentMedicalBill?.tf_accounting?.[0]}
        />
      )}
      {showLoanModal && (
        <EditLoans
          show={showLoanModal}
          handleClose={handleLoanClose}
          loan={currentLoan}
          setData={setLoans}
          updateLoansState={updateLoansState}
        />
      )}
      {showErrorModal && (
        <SettlementErrorModal
          show={showErrorModal}
          handleClose={handleErrorClose}
          errorMsg={errorMsg}
          updateStates={updateMedicalBillsState}
        />
      )}
      {showErrorLoanModal && (
        <SettlementErrorModal
          show={showErrorLoanModal}
          handleClose={handleLoanErrorClose}
          errorMsg={errorMsg}
          updateStates={updateLoansState}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          panelLabel={"CaseProviders"}
          finalAmount={currentMedicalBill.final}
          panelName={"provider"}
          panelEntity={currentMedicalBill}
          contact_obj={currentMedicalBill?.treatment_location}
          updateStates={() => {
            updateMedicalBillsState();
            clientProceeds.updateClientProceedsState();
          }}
        />
      )}
      {showLoanCheckRequestModal && (
        <SettlementCheckRequest
          show={showLoanCheckRequestModal}
          handleClose={handleLoanCheckRequestClose}
          panelLabel={"CaseLoans"}
          finalAmount={currentLoan?.final}
          panelName={"loans"}
          panelEntity={currentLoan}
          contact_obj={currentLoan?.lending_company_contact || currentLoan?.contact}
          updateStates={() => {
            updateLoansState();
            clientProceeds.updateClientProceedsState();
          }}
        />
      )}
    </div>
  );
};

export default SettlementTable;
